export function getDomain(window: Window, siteUrl = process.env.REACT_APP_SITE_URL) {
  if (siteUrl) return new URL(siteUrl).origin;
  return new URL(window.location.href).origin;
}
